module.exports = __webpack_public_path__ + "img/toughMinded3.5a70dd5c.png";